<div class="flex items-center gap-10 border-b border-gray-300 pb-4 px-6 mt-6">
  <onafriq-icon
    [icon]="incident.status === 'Active' ? 'approve' : incident.status === 'Down' ? 'limits' : 'laundering'"
    [color]="incident.status === 'Active' ? 'green-600' : incident.status === 'Down' ? 'red-600' : 'primary'"
    class="justify-center" />

  <div class="flex flex-col gap-1.5">
    <h4 class="text-h4">{{ incident.partnerName }}</h4>
    <p class="text-xs">{{ incident.description }}</p>
    <p
      class="text-xs"
      [ngClass]="
        incident.status === 'Active' ? 'text-green-600' : incident.status === 'Down' ? 'text-red-600' : 'text-primary'
      ">
      Status: <span>{{ incident.status }}</span>
    </p>
  </div>
</div>
